// @flow
import React from 'react';
import { Redirect } from 'react-router-dom';
import { Route } from 'react-router-dom';

export default function PrivateRoute({ children, ...rest }: any) {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        localStorage.getItem('authToken') ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}
